import * as httpClient from '../utils/httpClient';
import { logger } from '../utils/logger';

export const fetchMoorings = async (fetchMooringsQuery, requestContext) => {
  try {
    const headers = requestContext?.headers;
    const requestData = { params: fetchMooringsQuery };
    const apiClient = httpClient.getHttpClient(headers);
    const mooringsResponse = await apiClient.get('/product/search?type=mooring', requestData);
    return { mooringsResponse, error: null };
  } catch (err) {
    logger.error('getMoorings error', err);
    return { mooringsResponse: null, error: err };
  }
};
